import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  reportData: null,
  units: [],
  loading: false,
  exportLoading: false,
  pdfExportLoading: false,
  error: null,
  successMessage: null,
  // Filters
  filterUnitId: '',
  filterFromDate: '',
  filterToDate: '',
};

const violationReportSlice = createSlice({
  name: 'violationReport',
  initialState,
  reducers: {
    // Fetch init data (units)
    fetchInit: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchInitSuccess: (state, action) => {
      state.loading = false;
      state.units = action.payload.units || [];
      state.error = null;
    },
    fetchInitFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Fetch violation report
    fetchViolationReport: (state) => {
      state.loading = true;
      state.error = null;
      state.reportData = null; // Clear old data before fetching new data
    },
    fetchViolationReportSuccess: (state, action) => {
      state.loading = false;
      state.reportData = action.payload;
      state.error = null;
    },
    fetchViolationReportFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Filters
    setFilterUnitId: (state, action) => {
      state.filterUnitId = action.payload;
    },
    setFilterFromDate: (state, action) => {
      state.filterFromDate = action.payload;
    },
    setFilterToDate: (state, action) => {
      state.filterToDate = action.payload;
    },

    // Clear filters
    clearFilters: (state) => {
      state.filterUnitId = '';
      state.filterFromDate = '';
      state.filterToDate = '';
      state.reportData = null;
    },

    // Export to Excel
    exportViolationReportToExcel: (state) => {
      state.exportLoading = true;
      state.error = null;
    },
    exportViolationReportToExcelSuccess: (state, action) => {
      state.exportLoading = false;
      state.successMessage = action.payload;
      state.error = null;
    },
    exportViolationReportToExcelFailure: (state, action) => {
      state.exportLoading = false;
      state.error = action.payload;
    },

    // Export to PDF
    exportViolationReportToPdf: (state) => {
      state.pdfExportLoading = true;
      state.error = null;
    },
    exportViolationReportToPdfSuccess: (state, action) => {
      state.pdfExportLoading = false;
      state.successMessage = action.payload;
      state.error = null;
    },
    exportViolationReportToPdfFailure: (state, action) => {
      state.pdfExportLoading = false;
      state.error = action.payload;
    },

    // Clear messages
    clearError: (state) => {
      state.error = null;
    },
    clearSuccessMessage: (state) => {
      state.successMessage = null;
    },
  },
});

export const {
  fetchInit,
  fetchInitSuccess,
  fetchInitFailure,
  fetchViolationReport,
  fetchViolationReportSuccess,
  fetchViolationReportFailure,
  exportViolationReportToExcel,
  exportViolationReportToExcelSuccess,
  exportViolationReportToExcelFailure,
  exportViolationReportToPdf,
  exportViolationReportToPdfSuccess,
  exportViolationReportToPdfFailure,
  setFilterUnitId,
  setFilterFromDate,
  setFilterToDate,
  clearFilters,
  clearError,
  clearSuccessMessage,
} = violationReportSlice.actions;

// Selectors
export const selectViolationReportData = (state) => state.violationStatistics?.reportData;
export const selectViolationReportUnits = (state) => state.violationStatistics?.units || [];
export const selectViolationReportLoading = (state) => state.violationStatistics?.loading || false;
export const selectViolationReportExportLoading = (state) => state.violationStatistics?.exportLoading || false;
export const selectViolationReportPdfExportLoading = (state) => state.violationStatistics?.pdfExportLoading || false;
export const selectViolationReportError = (state) => state.violationStatistics?.error;
export const selectViolationReportSuccessMessage = (state) => state.violationStatistics?.successMessage;
export const selectViolationReportFilterUnitId = (state) => state.violationStatistics?.filterUnitId ?? '';
export const selectViolationReportFilterFromDate = (state) => state.violationStatistics?.filterFromDate || '';
export const selectViolationReportFilterToDate = (state) => state.violationStatistics?.filterToDate || '';

export default violationReportSlice.reducer;
